
// components/TopStatusBar.jsx
import React from 'react';

const TopStatusBar = ({ currentEmotion, sessionActive, sessionStartTime }) => {
  return (
    <div className="top-status-bar">
      <div className="status-left">
        {currentEmotion && (
          <div className="emotion-indicator">
            <span className="emotion-text">{currentEmotion}</span>
          </div>
        )}
        {sessionActive && (
          <div className="session-status">
            <span>Session: {sessionStartTime ? Math.floor((Date.now() - sessionStartTime.getTime()) / 1000) : 0}s</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopStatusBar;
